import script from "./AdtOrder.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdtOrder.vue?vue&type=script&lang=ts&setup=true"

import "./AdtOrder.vue?vue&type=style&index=0&id=26def42a&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26def42a"]])

export default __exports__